<template>
  <div class="hello">
    <div v-if="loader">
      <Loader/>
    </div>
    <div v-else class="survey-banner">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12 iq-login-regi">
            <div class="align-items-center d-flex justify-content-center iq-login">
              <form class="iq-loginbox">
                <div>
                  <small class="text-danger" v-if="isStartClicked && !personID">
                  {{requiredTextPerson}}
                  </small>
                  <div class="login-boxes mb-3">
                    <input type="text" class="form-control email-bg" id="exampleInputEmail1" :placeholder="placeHolderTextPerson" v-model="personID">
                  </div>
                </div>
              </form>
              <form class="iq-loginbox">
                <div>
                  <small class="text-danger" v-if="isStartClicked && !doctorName">
                  {{requiredTextDoctor}}
                  </small>
                  <div class="login-boxes mb-3">
                    <input type="text" class="form-control email-bg" id="exampleInputEmail" :placeholder="placeHolderTextDoctor" v-model="doctorName">
                  </div>
                </div>
              </form>
            </div>
            <!-- <div class="align-items-center d-flex justify-content-center">
              <h3>{{headerText}}</h3>
            </div> -->
            <hr>
            <!-- <div class="align-items-center d-flex justify-content-center">
              <a>{{descriptionText}}</a>
            </div> -->
            <div class="align-items-center justify-content-center">
              <a><span>{{DateOfDescription}} {{ date | moment }}</span></a>
            </div>
            <br>
              <div>
                <form> 
                  <fieldset> 
                    <legend>{{entryPerson}}</legend> 
                    <small class="text-danger" v-if="isStartClicked && !picked">
                      {{requiredTextFiller}}
                    </small>
                    <div>
                      <h5>
                        <label class="radio-btn"> 
                          <input type="radio" v-model="picked" value="1"/> 
                            {{filler}} 
                        </label>
                      </h5>
                      <small class="text-danger" v-if="isStartClicked && picked == '2' && !relation">
                        {{requiredTextFiller}}
                      </small>
                      <div>
                        <h5>
                          <label class="radio-btn"> 
                            <input type="radio" v-model="picked" value="2"/> 
                              {{fillerRelative}}
                            <input v-model="relation" :placeholder="placeholderTextRelation">
                          </label>
                        </h5>
                      </div>
                    </div>
                  </fieldset> 
                </form> 
              </div>
            <br>
            <div class="align-items-center d-flex justify-content-center">
              <button type="submit " class="button" v-on:click="startClicked">{{startButtonText}}</button>
            </div>
            
          </div>

        </div>
      </div>
    </div>
    <!-- <div class="main-content">
      <section class="how-it-works conection-shap">
        <div class="container">
          
        </div>
      </section>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'

export default {
  filters: {
    moment (date) {
      return moment(date).format('YYYY/MM/DD')
    }
  },
  components: {
    Loader: () => import('@/components/Loader.vue')
  },
  data () {
    return {
      loader: true,
      date: moment(),
      language: "ja",
      picked: '',
      relation: '',
      personID: '',
      doctorName: '',
      validate: false,
      isStartClicked: false,
      DateOfDescription: '記載日（西暦）:',
      entryPerson: '記入者:',
      filler: '本人',
      fillerRelative: '本人以外',
      startButtonText: '開始',
      headerText: '肺非結核性抗酸菌症ならびに気管支拡張症の診療のための問診票',
      descriptionText: "皆さんの健康状態について記載をお願い致します。質問の内容には、普段主治医が質問してい る内容も重複していますが、現在の正確な病状を記録するため、改めてお尋ねします。この情 報は主治医が確認して普段の診療にいかされるとともに、個人情報を完全に消去した上で他の 患者さんの情報とあわせて分析されます。下記項目にお答えください。（該当する項目にレを 記入してください）",
      placeHolderTextPerson: 'あなたの身元を入力してください',
      placeHolderTextDoctor: '主治医名を入力してください',
      placeholderTextRelation: '関係',
      requiredTextPerson: 'あなたのIDが必要です',
      requiredTextDoctor: '担当の先生の名前',
      requiredTextFiller: 'この項目がは必須です。',
      goToHomeText: 'アンケート一覧へ',
      savingMsg: '結果はサーバーに保存されています...',
      successMsg: '結果は正常に保存されました！',
      failedMsg: 'エラーが発生したため、結果を保存できませんでした。',
    }
  },
  computed: {
    SiteLanguage () {
      return this.$store.state.siteLanguage
    }
  },
  watch: {
    SiteLanguage (newSiteLanguage, oldSiteLanguage) {
      this.setLanguage(newSiteLanguage);
    }
  },
  created () {
    this.setLanguage(this.$store.state.siteLanguage);
    this.loader = false
  },
  mounted() {
    // when user is logged in then redirecting user from suverview page to surveylist page
    if(this.$store.state.user) {
      this.$router.push('/survey-list').then(res => {}).catch(err => {})
    }
  },
  methods: {
    async startClicked(event){
      event.preventDefault();
      this.isStartClicked = true;
      if(this.personID && this.doctorName && this.picked) {
        try{
          const res = await this.$store.dispatch('getUser', { userId: this.personID })
        }catch(err) {
          console.log(err)
        }
        localStorage.setItem('setPersonId', this.personID)
        this.$store.commit('setPersonId', this.personID)
        if (this.picked == '2' && this.relation) {
          this.$router.push('/survey-list').catch(err => {})
          this.$store.commit('setDoctorName', this.doctorName);
          this.$store.commit('setFiller', this.relation);
        }
        else if (this.picked == '1') {
          this.$router.push('/survey-list').catch(err => {})
          this.$store.commit('setDoctorName', this.doctorName);
          this.$store.commit('setFiller', this.personID);
        }
      }
    },
    setLanguage(siteLanguage){
      // this.survey.locale = siteLanguage
      if(siteLanguage==="ja"){
        this.DateOfDescription = '記載日（西暦）:',
        this.filler = '本人',
        this.fillerRelative = '本人以外',
        this.entryPerson = '記入者:',
        this.startButtonText = "開始";
        this.headerText = '肺非結核性抗酸菌症ならびに気管支拡張症の診療のための問診票',
        this.descriptionText = '皆さんの健康状態について記載をお願い致します。質問の内容には、普段主治医が質問してい る内容も重複していますが、現在の正確な病状を記録するため、改めてお尋ねします。この情 報は主治医が確認して普段の診療にいかされるとともに、個人情報を完全に消去した上で他の 患者さんの情報とあわせて分析されます。下記項目にお答えください。（該当する項目にレを 記入してください）',
        this.placeHolderTextPerson = "あなたのIDを入力してください";
        this.placeHolderTextDoctor = '担当先生の名前';
        this.placeholderTextRelation = '関係';
        this.requiredTextPerson = 'あなたのIDが必要です';
        this.requiredTextDoctor = '医師の名前が必要です';
        this.requiredTextFiller = 'この項目は必須です。';
        this.goToHomeText = 'アンケート一覧へ';
        this.savingMsg = '結果はサーバーに保存されています...';
        this.successMsg = '結果は正常に保存されました！';
        this.failedMsg = 'エラーが発生したため、結果を保存できませんでした。';
      }
      else{
        this.DateOfDescription = 'Date of description (AD):',
        this.filler = 'The person',
        this.fillerRelative = 'Other than the person',
        this.entryPerson = 'Entry person:'
        this.startButtonText = 'Start';
        this.headerText = 'Questionnaire for the treatment of nontuberculous mycobacteriosis and bronchiectasis',
        this.descriptionText = "Please describe your health condition. The content of the question is usually asked by the attending physician Although the contents are duplicated, I will ask you again to record the current accurate medical condition. This feeling The information will be confirmed by the attending physician and used for daily medical care, and after the personal information has been completely erased, other information will be used. It will be analyzed together with the patient's information. Please answer the following items. (Check the applicable items Please fill in)",
        this.placeHolderTextPerson = 'Please enter your ID';
        this.placeHolderTextDoctor = 'Attending doctor name';
        this.placeholderTextRelation = 'Relationship'
        this.requiredTextPerson = 'Your ID is required';
        this.requiredTextDoctor = 'Attending doctor name is required';
        this.requiredTextFiller = 'The activity field is required.';
        this.goToHomeText = 'Go to Home Page';
        this.savingMsg = 'The results are saving on the server...';
        this.successMsg = 'The results were saved successfully!';
        this.failedMsg = 'An error occurred and we could not save the results.';
      }
    }
  }
}
</script>

<style scoped>
.survey-banner {
  padding: 150px 90px 65px 90px;
}
</style>

<style lang="scss">
.iq-login-regi {
  padding: 0px;
  .iq-login {
    border: none;
  }
}
.progress-bar {
  background-color: #28a745;
}
.radio-btn {
  width: 100%
}
.progress {
  width: 100% !important;
  height: 1.5rem !important;
  background-color: #E0E0E0;
}
.panel-footer {
  display: flex;
  justify-content: space-between;
  .sv_prev_btn {
    background-color: #f0831e;
    color: #fff;
  }
  .sv_next_btn {
    background-color: #28a745;
    color: #fff;
  }
  .sv_complete_btn {
    background-color: #28a745;
    color: #fff;
  }
}
</style>